// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ExpiredEmail-module-container-hl-k4{max-width:90%;width:100%;margin-block:44px 12px;margin-inline:auto}@media(min-width: 960px){.ExpiredEmail-module-container-hl-k4{margin-block:44px 40px;margin-inline:auto;max-width:940px}}.ExpiredEmail-module-text-FgwJY{font-size:14px;font-weight:var(--weight-light);letter-spacing:0;line-height:23px}@media(min-width: 960px){.ExpiredEmail-module-text-FgwJY{font-size:16px}}.ExpiredEmail-module-submitBtn-svJQS{margin-top:10px;width:100%}@media(min-width: 960px){.ExpiredEmail-module-submitBtn-svJQS{width:auto;width:initial}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "ExpiredEmail-module-container-hl-k4",
	"text": "ExpiredEmail-module-text-FgwJY",
	"submitBtn": "ExpiredEmail-module-submitBtn-svJQS"
};
export default ___CSS_LOADER_EXPORT___;
